<template>
  <div v-if="fields.length > 0">
    <div class="admin__header">
      <div>
        <h1 class="no-margin">Fields</h1>
        <div class="page__subtitle">{{ activeScreen.title }}</div>
      </div>
      <router-link :to="newFieldRoute" class="actions__action secondary-button">Add Field</router-link>
    </div>
    <div class="list-view list-view--stack-wide list-view--admin-fields">
      <div class="list-view__header">
        <div class="list-view__small-column">Position</div>
        <div>Title</div>
        <div>Field Type</div>
        <div class="list-view__small-column">Required</div>
        <div class="list-view__small-column">Actions</div>
      </div>
      <div class="list-view__row" v-for="(field, index) in fields" :key="field.id">
        <div class="list-view__small-column">
          <span class="show-for-small">Position: </span>
          {{ field.position }}
        </div>
        <div>
          <router-link :to="editFieldRoute(field.id)">
            {{ field.title }}
          </router-link>
        </div>
        <div>{{ fieldTypes[field.field_type].name }}</div>
        <div class="list-view__small-column">
          <span class="show-for-small">Required: </span>
          <i class="fa-solid fa-check" v-if="field.required" />
          <i class="fa-solid fa-xmark" v-else />
        </div>
        <div class="list-view__small-column list-actions list-actions--stacked">
          <div class="list-actions__group">
            <button class="icon-button list-action" @click="alterPosition(field.id, field.position - 1)" :disabled="index === 0">
              <i class="fa-solid fa-arrow-up" />
              <span class="list-action__label">Move Up</span>
            </button>
            <button class="icon-button list-action" @click="alterPosition(field.id, field.position + 1)"
              :disabled="index === fields.length - 1">
              <i class="fa-solid fa-arrow-down" />
              <span class="list-action__label">Move Down</span>
            </button>
          </div>
          <div class="list-actions__group">
            <router-link :to="editFieldRoute(field.id)" class="list-action">
              <i class="fa-solid fa-pen-to-square" />
              <span class="list-action__label">Edit</span>
            </router-link>
            <button class="icon-button list-action" @click="deleteField(field)">
              <i class="fa-solid fa-trash" />
              <span class="list-action__label">Delete</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <no-items v-else :parent="activeScreen.title" name="Field" icon="inbox-in" new-link="admin-new-field" />
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import Common from '@/common';
import NoItems from '@/components/NoItems';

export default {
  name: 'admin-fields',

  components: { NoItems },

  computed: {
    ...mapState({
      fields: state => state.admin.field.fields,
      fieldTypes: state => state.field.inputTypes,
    }),

    ...mapGetters('admin', [
      'activeScreen',
    ]),

    contextQuery() {
      return Object.keys(this.$route.query).length > 0 ? this.$route.query : null;
    },

    newFieldRoute() {
      const route = { name: 'admin-new-field' };
      if (this.contextQuery) route.query = this.contextQuery;
      return route;
    },
  },

  methods: {
    editFieldRoute(fieldId) {
      const route = { name: 'admin-edit-field', params: { fieldId } };
      if (this.contextQuery) route.query = this.contextQuery;
      return route;
    },

    deleteField(field) {
      Common.confirmDialog({
        modal: this.$modal,
        title: `Are you sure you want to delete ${field.title}?`,
        okHandler: () => {
          this.$store.dispatch('admin/deleteField', {
            screenId: this.activeScreen.id,
            fieldId: field.id,
          });
        },
      });
    },

    alterPosition(fieldId, position) {
      this.$store.dispatch('admin/editField', { data: { id: fieldId, position }, noCommit: true })
        .then(() => this.$store.dispatch('admin/fetchFields', { dependsOn: this.activeScreen.id }));
    },
  },
};
</script>
